<template>
	<EmailField
		v-model="email"
		:errors="errors?.email"
		:show-label="false"
		@keyup:enter="loginHandler"
	/>

	<PasswordField
		v-model="pass"
		:errors="errors?.password"
		:show-label="false"
		@keyup:enter="loginHandler"
	/>

	<button
		:disabled="isLoginDisabled || loading"
		class="
            relative mt-4 flex w-full items-center justify-center
            rounded bg-won-green p-2.5 text-white
            hover:opacity-90 disabled:bg-won-gray disabled:opacity-40
        "
		@click="loginHandler"
	>
		<span
			class="text-white"
			:class="{'opacity-0' : loading}"
		>
			Login
		</span>

		<span
			v-if="loading"
			class="absolute"
		>
			<LoadingIcon
				:class="{'opacity-0' : !loading}"
			/>
		</span>
	</button>
</template>

<script setup>
import { shallowRef, computed, toRefs } from 'vue';

import PasswordField from '../password-field.vue';
import EmailField from '../email-field.vue';
import LoadingIcon from '../../../icons/loading-icon.vue';

const emit = defineEmits(['login']);
const props = defineProps({
	loading: {
		type: Boolean,
		default: false
	},
	errors: {
		type: Object,
		default: () => ({})
	}
});

const { loading } = toRefs(props);

const email = shallowRef('');
const pass = shallowRef('');

const loginHandler = () => {
	emit('login', {
		email: email.value,
		password: pass.value,
	});
};

const isLoginDisabled = computed(() => {
	return !email.value?.length || loading.value === true
		|| !pass.value?.length;
});
</script>
